<script>
	let currentIndex = 0
	let startX
	let startXm
	let isDragging = false
	export let slides = [
		{
			quote: 'Slide 1',
			cite: 'hh for slide 1'
		},
		{
			quote: 'Slide 2',
			cite: 'hh for slide 2'
		},
		{
			quote: 'Slide 3',
			cite: 'hh for slide 3'
		}
	]

	function handlePrevClick() {
		currentIndex = (currentIndex - 1 + slides.length) % slides.length
	}

	function handleNextClick() {
		currentIndex = (currentIndex + 1) % slides.length
	}

	function handleDotClick(index) {
		if (isDragging) {
			return
		}
		currentIndex = index
	}
	function handleTouchStart(event) {
		startX = event.touches[0].clientX
		isDragging = true
	}

	function handleTouchMove(event) {
		if (!isDragging) {
			return
		}

		let currentX = event.touches[0].clientX
		let deltaX = currentX - startX

		if (Math.abs(deltaX) > 50) {
			if (deltaX > 0) {
				handlePrevClick()
			} else {
				handleNextClick()
			}
			isDragging = false
		}
	}
	function handleMouseDown(event) {
		startXm = event.clientX
		isDragging = true
	}

	function handleMouseMove(event) {
		if (!isDragging) {
			return
		}

		let currentX = event.clientX
		let deltaX = currentX - startXm

		if (Math.abs(deltaX) > 50) {
			if (deltaX > 0) {
				handlePrevClick()
			} else {
				handleNextClick()
			}
			isDragging = false
		}
	}

	function handleTouchEnd() {
		isDragging = false
	}
</script>

<div
	class="slider"
	on:mousedown={handleMouseDown}
	on:mousemove={handleMouseMove}
	on:mouseup={handleTouchEnd}
	on:touchstart={handleTouchStart}
	on:touchmove={handleTouchMove}
	on:touchend={handleTouchEnd}
	role="slider"
	tabindex="0"
	aria-orientation="horizontal"
	aria-valuenow={currentIndex}
>
	<div class="slider-frame">
		{#each slides as slide, i}
			<div
				on:keypress={() => (i !== currentIndex ? handleDotClick(i) : false)}
				on:click={() => (i !== currentIndex ? handleDotClick(i) : false)}
				class="slider-item text-pri select-none rounded-2xl bg-white p-8 {i === currentIndex
					? 'active'
					: 'inactive'}"
				role="button"
				tabindex="0"
			>
				<div class="center absolute -top-10 text-8.5xl font-light text-neutral-300">&ldquo;</div>
				<div class="flex h-full items-center">
					<div>
						<p class="text-2xl italic md:text-3.5xl">{@html slide.quote}</p>
						<p class="font-semibold">{slide.cite}</p>
					</div>
				</div>
				<div class="center absolute -bottom-24 right-0 text-8.5xl font-light text-neutral-300">
					&ldquo;
				</div>
			</div>
		{/each}
	</div>
	<div class="slider-dots">
		{#each slides as _slide, i}
			<button
				class="slider-dot {i === currentIndex ? 'active' : ''}"
				on:keypress={() => handleDotClick(i)}
				on:click={() => handleDotClick(i)}
				tabindex="0"
			/>
		{/each}
	</div>
</div>

<style>
	.slider {
		width: 100%;
		height: 400px;
		position: relative;
	}
	.slider-frame {
		width: 100%;
		height: 350px;
		position: relative;
	}
	.slider-item {
		transition: all 0.3s;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: -120%;
		box-shadow: 0 0 2em #f5f5f5;
	}
	.slider-item.active {
		left: 0;
	}
	.slider-dots {
		display: flex;
		justify-content: center;
		margin-top: 10px;
	}
	.slider-dot {
		width: 16px;
		height: 16px;
		border: 3px solid #f5f5f5;
		border-radius: 50%;
		background-color: #ccc;
		margin: 5px;
		cursor: pointer;
	}
	.slider-dot.active {
		background-color: #e01f26;
		border-color: #e01f26;
	}
</style>
